import { createContext, useContext, useEffect, useState } from "react";

export const LANGS = [
    { code: "en", label: "EN" },
    { code: "te", label: "తెలుగు" },
    { code: "ur", label: "اردو" },
];

export const T = {
    en: {
        nav: {
            call: "Call Now",
            download: "Download App",
            links: [
                { href: "#services", label: "Services" },
                { href: "#install", label: "Install Guide" },
                { href: "#book", label: "Book Now" },
                { href: "#contact", label: "Contact" },
            ],
        },
        app: {
            name: "Azmthullah Packers & Movers",
            short: "Azmthullah P&M",
            devLine: "Azmthullah Packers & Movers — Rayachoty, Andhra Pradesh",
            metaLine: "Official app • Direct APK download • Android",
            dlBtn: "Download App",
            callBtn: "Call Now",
            waBtn: "WhatsApp",
            dlNote: "Direct APK download for all Android phones • Install guide included",
            stats: [
                { v: "Rayachoty", l: "Based in" },
                { v: "5", l: "Services" },
                { v: "APK", l: "Direct download" },
                { v: "Free", l: "Quote" },
            ],
            playVideo: "Play video",
            shotsLabel: "Azmthullah Packers & Movers in action",
            file: "Azmthullah_Packers_Movers.apk",
        },
        about: {
            title: "About this app",
            text: "Azmthullah Packers & Movers is a trusted moving team from Rayachoty, Andhra Pradesh. We pack and shift homes and offices with trained labour, dedicated vehicles and honest pricing. Book a truck in one tap — or just call us.",
            more: "See our services",
        },
        marquee: [
            "House Shifting",
            "Office Shifting",
            "Packers & Movers",
            "Loading & Unloading",
            "Transportation",
            "Rayachoty, Andhra Pradesh",
        ],
        services: {
            eyebrow: "Our services",
            title: "Everything your move needs",
            sub: "From packing to delivery — all in one place.",
            items: [
                { t: "Packers & Movers", d: "Complete packing with bubble wrap, corrugated sheets and stretch film for fragile goods." },
                { t: "House Shifting", d: "Hassle-free home relocation — packed, loaded and delivered room to room." },
                { t: "Office Shifting", d: "Quick, systematic commercial relocation with minimal downtime for your business." },
                { t: "Loading & Unloading", d: "Trained labour team for safe loading, unloading and careful placement of heavy furniture." },
                { t: "Transportation", d: "Clean, dedicated trucks and pickup vehicles for fast, direct dispatch." },
            ],
        },
        install: {
            eyebrow: "Install guide",
            title: "Install the app in 4 simple steps",
            sub: "Downloading an APK is safe and easy. Android will ask your permission once — here is exactly what to do.",
            steps: [
                "Tap the Download App button — the APK file starts downloading.",
                "Open your Notifications or Downloads folder and tap Azmthullah_Packers_Movers.apk.",
                "If Android asks, tap Settings → allow “Install unknown apps” for your browser, then come back and tap Install.",
                "Tap Open — the app is ready. Book a truck in under a minute.",
            ],
            note: "Your phone may show a security warning because this app is not from the Play Store. That is normal for direct APK downloads — it is safe to allow installs from this website only.",
            dlBtn: "Download App (APK)",
        },
        form: {
            eyebrow: "Book your move",
            title: "Get a free quote in 1 minute",
            sub: "Fill the form — we save your enquiry and call you back with the best price.",
            f: {
                name: "Your name",
                phone: "Phone number",
                from: "Moving from",
                to: "Moving to",
                service: "Service required",
                date: "Preferred date",
                details: "Items / details (optional)",
            },
            ph: {
                name: "e.g. Mohammed",
                phone: "e.g. 99599 54280",
                from: "e.g. Rayachoty",
                to: "e.g. Bangalore",
                details: "e.g. 1 BHK, fridge, washing machine",
            },
            services: ["Packers & Movers", "House Shifting", "Office Shifting", "Loading & Unloading", "Transportation"],
            pick: "Choose a service",
            submit: "Get Free Quote",
            sending: "Sending…",
            success: {
                title: "Enquiry received!",
                sub: "Thank you. Your enquiry is saved — our team will call you shortly. You can also download the app right now.",
                apk: "Download the App (APK)",
                apkHint: "Your enquiry details are saved. The app download starts right away.",
                wa: "Send details on WhatsApp",
                call: "Call Now",
                again: "Make another enquiry",
            },
        },
        contact: {
            eyebrow: "Visit or call us",
            title: "We are here in Rayachoty",
            addressLabel: "Address",
            phoneLabel: "Phone",
            call: "Call Now",
            wa: "WhatsApp",
            directions: "Get Directions",
            waNote: "Tap a number to start a WhatsApp chat.",
        },
        modal: {
            title: "Install the Azmthullah app",
            sub: "Your download has started. Follow these steps to install:",
            got: "Got it",
            again: "Download again",
        },
        ctaBar: { download: "Download App", call: "Call Now" },
        footer: {
            tag: "Packers & Movers — Rayachoty, Andhra Pradesh.",
            rights: "All rights reserved.",
            apkNote: "Official Android APK • Direct download • Install guide included",
        },
    },

    te: {
        nav: {
            call: "ఇప్పుడే కాల్ చేయండి",
            download: "యాప్ డౌన్‌లోడ్",
            links: [
                { href: "#services", label: "సేవలు" },
                { href: "#install", label: "ఇన్‌స్టాల్ గైడ్" },
                { href: "#book", label: "బుక్ చేయండి" },
                { href: "#contact", label: "సంప్రదించండి" },
            ],
        },
        app: {
            name: "అజ్మతుల్లా ప్యాకర్స్ & మూవర్స్",
            short: "Azmthullah P&M",
            devLine: "అజ్మతుల్లా ప్యాకర్స్ & మూవర్స్ — రాయచోటి, ఆంధ్రప్రదేశ్",
            metaLine: "అధికారిక యాప్ • నేరుగా APK డౌన్‌లోడ్ • Android",
            dlBtn: "యాప్ డౌన్‌లోడ్ చేయండి",
            callBtn: "ఇప్పుడే కాల్ చేయండి",
            waBtn: "వాట్సాప్",
            dlNote: "అన్ని Android ఫోన్‌ల కోసం నేరుగా APK డౌన్‌లోడ్ • ఇన్‌స్టాల్ గైడ్ అందుబాటులో",
            stats: [
                { v: "రాయచోటి", l: "ప్రధాన కేంద్రం" },
                { v: "5", l: "సేవలు" },
                { v: "APK", l: "నేరుగా డౌన్‌లోడ్" },
                { v: "ఉచితం", l: "కోట్" },
            ],
            playVideo: "వీడియో ప్లే చేయండి",
            shotsLabel: "అజ్మతుల్లా ప్యాకర్స్ & మూవర్స్ — మా పని",
            file: "Azmthullah_Packers_Movers.apk",
        },
        about: {
            title: "ఈ యాప్ గురించి",
            text: "అజ్మతుల్లా ప్యాకర్స్ & మూవర్స్ — రాయచోటికి చెందిన నమ్మకమైన టీమ్. శిక్షణ పొందిన సిబ్బంది, ప్రత్యేక వాహనాలు, న్యాయమైన ధరలతో ఇళ్లు, ఆఫీసులు తరలిస్తాం. ఒక్క ట్యాప్‌లో ట్రక్ బుక్ చేయండి — లేదా మాకు కాల్ చేయండి.",
            more: "మా సేవలు చూడండి",
        },
        marquee: [
            "ఇల్లు తరలింపు",
            "ఆఫీస్ తరలింపు",
            "ప్యాకర్స్ & మూవర్స్",
            "లోడింగ్ & అన్‌లోడింగ్",
            "రవాణా",
            "రాయచోటి, ఆంధ్రప్రదేశ్",
        ],
        services: {
            eyebrow: "మా సేవలు",
            title: "మీ తరలింపుకు కావలసినవన్నీ",
            sub: "ప్యాకింగ్ నుండి డెలివరీ వరకు — అన్నీ ఒకే చోట.",
            items: [
                { t: "ప్యాకర్స్ & మూవర్స్", d: "బుడబుడు ర్యాప్, కరగాటి షీట్లతో బ్రేకబడే వస్తువులకు పూర్తి ప్యాకింగ్." },
                { t: "ఇల్లు తరలింపు", d: "ఇంటి నుండి ఇంటికి — ప్యాకింగ్, లోడింగ్, డెలివరీ అన్నీ మేమే." },
                { t: "ఆఫీస్ తరలింపు", d: "మీ వ్యాపారానికి ఆటంకం లేకుండా వేగవంతమైన ఆఫీస్ తరలింపు." },
                { t: "లోడింగ్ & అన్‌లోడింగ్", d: "భారీ ఫర్నిచర్‌ను సురక్షితంగా ఎక్కించి దింపుతాం — శిక్షణ పొందిన సిబ్బంది." },
                { t: "రవాణా", d: "వేగవంతమైన రవాణా కోసం ప్రత్యేక క్లోజ్డ్ ట్రక్కులు, పికప్ వాహనాలు." },
            ],
        },
        install: {
            eyebrow: "ఇన్‌స్టాల్ గైడ్",
            title: "4 సరళ దశల్లో యాప్‌ను ఇన్‌స్టాల్ చేయండి",
            sub: "APK డౌన్‌లోడ్ చేయడం సురక్షితమే. Android ఒకసారి అనుమతి అడుగుతుంది — ఏమి చేయాలో ఇక్కడ ఉంది.",
            steps: [
                "డౌన్‌లోడ్ యాప్ బటన్‌ను నొక్కండి — APK ఫైల్ డౌన్‌లోడ్ అవుతుంది.",
                "నోటిఫికేషన్స్ లేదా డౌన్‌లోడ్స్ ఫోల్డర్ తెరిచి, Azmthullah_Packers_Movers.apk నొక్కండి.",
                "Android అడిగితే — Settings లో మీ బ్రౌజర్‌కు “Install unknown apps” అనుమతించి, తిరిగి వచ్చి Install నొక్కండి.",
                "Open నొక్కండి — యాప్ సిద్ధం. ఒక్క నిమిషంలో ట్రక్ బుక్ చేయండి.",
            ],
            note: "ఈ యాప్ Play Store నుండి కాదు కాబట్టి ఫోన్ భద్రతా హెచ్చరిక చూపవచ్చు. ఈ వెబ్‌సైట్ నుండి మాత్రమే ఇన్‌స్టాల్ అనుమతించడం సురక్షితం.",
            dlBtn: "యాప్ డౌన్‌లోడ్ (APK)",
        },
        form: {
            eyebrow: "మీ తరలింపు బుక్ చేయండి",
            title: "1 నిమిషంలో ఉచిత కోట్ పొందండి",
            sub: "ఫారమ్ పూరించండి — మేము మీ వివరాలు సేవ్ చేసి, ఉత్తమ ధరతో కాల్ చేస్తాం.",
            f: {
                name: "మీ పేరు",
                phone: "ఫోన్ నంబర్",
                from: "ఎక్కడి నుండి",
                to: "ఎక్కడికి",
                service: "కావలసిన సేవ",
                date: "కావలసిన తేదీ",
                details: "సామాను / వివరాలు (ఐచ్ఛికం)",
            },
            ph: {
                name: "ఉదా: మొహమ్మద్",
                phone: "ఉదా: 99599 54280",
                from: "ఉదా: రాయచోటి",
                to: "ఉదా: బెంగళూరు",
                details: "ఉదా: 1 BHK, ఫ్రిజ్, వాషింగ్ మెషీన్",
            },
            services: ["ప్యాకర్స్ & మూవర్స్", "ఇల్లు తరలింపు", "ఆఫీస్ తరలింపు", "లోడింగ్ & అన్‌లోడింగ్", "రవాణా"],
            pick: "సేవను ఎంచుకోండి",
            submit: "ఉచిత కోట్ పొందండి",
            sending: "పంపుతోంది…",
            success: {
                title: "మీ విచారణ అందింది!",
                sub: "ధన్యవాదాలు. మీ వివరాలు సేవ్ అయ్యాయి — మేము త్వరలో కాల్ చేస్తాం. ఇప్పుడే యాప్ డౌన్‌లోడ్ చేసుకోండి.",
                apk: "యాప్ డౌన్‌లోడ్ (APK)",
                apkHint: "మీ విచారణ సేవ్ చేయబడింది. యాప్ డౌన్‌లోడ్ వెంటనే ప్రారంభమవుతుంది.",
                wa: "వాట్సాప్‌లో వివరాలు పంపండి",
                call: "ఇప్పుడే కాల్ చేయండి",
                again: "మరో విచారణ చేయండి",
            },
        },
        contact: {
            eyebrow: "మమ్మల్ని సంప్రదించండి",
            title: "మేము రాయచోటిలో ఉన్నాం",
            addressLabel: "చిరునామా",
            phoneLabel: "ఫోన్",
            call: "కాల్ చేయండి",
            wa: "వాట్సాప్",
            directions: "దారి చూపించు",
            waNote: "చాట్ ప్రారంభించడానికి నంబర్‌ను నొక్కండి.",
        },
        modal: {
            title: "అజ్మతుల్లా యాప్‌ను ఇన్‌స్టాల్ చేయండి",
            sub: "డౌన్‌లోడ్ ప్రారంభమైంది. ఇన్‌స్టాల్ చేయడానికి ఈ దశలు పాటించండి:",
            got: "సరే",
            again: "మళ్లీ డౌన్‌లోడ్",
        },
        ctaBar: { download: "యాప్ డౌన్‌లోడ్", call: "కాల్ చేయండి" },
        footer: {
            tag: "ప్యాకర్స్ & మూవర్స్ — రాయచోటి, ఆంధ్రప్రదేశ్.",
            rights: "అన్ని హక్కులు రిజర్వ్ చేయబడినవి.",
            apkNote: "అధికారిక Android APK • నేరుగా డౌన్‌లోడ్ • ఇన్‌స్టాల్ గైడ్ అందుబాటులో",
        },
    },

    ur: {
        nav: {
            call: "ابھی کال کریں",
            download: "ایپ ڈاؤن لوڈ کریں",
            links: [
                { href: "#services", label: "ہماری خدمات" },
                { href: "#install", label: "انسٹال گائیڈ" },
                { href: "#book", label: "بک کریں" },
                { href: "#contact", label: "رابطہ" },
            ],
        },
        app: {
            name: "عظم اللہ پیکرز اینڈ موورز",
            short: "Azmthullah P&M",
            devLine: "عظم اللہ پیکرز اینڈ موورز — رایچوٹی، آندھرا پردیش",
            metaLine: "آفیشل ایپ • براہ راست APK ڈاؤن لوڈ • Android",
            dlBtn: "ایپ ڈاؤن لوڈ کریں",
            callBtn: "ابھی کال کریں",
            waBtn: "واٹس ایپ",
            dlNote: "تمام Android فونز کے لیے براہ راست APK ڈاؤن لوڈ • انسٹال گائیڈ شامل",
            stats: [
                { v: "رایچوٹی", l: "ہمارا مرکز" },
                { v: "5", l: "خدمات" },
                { v: "APK", l: "براہ راست ڈاؤن لوڈ" },
                { v: "مفت", l: "قیمت جانیں" },
            ],
            playVideo: "ویڈیو چلائیں",
            shotsLabel: "عظم اللہ پیکرز اینڈ موورز — ہمارا کام",
            file: "Azmthullah_Packers_Movers.apk",
        },
        about: {
            title: "اس ایپ کے بارے میں",
            text: "عظم اللہ پیکرز اینڈ موورز رایچوٹی، آندھرا پردیش کا قابلِ اعتماد ٹیم ہے۔ تربیت یافتہ عملہ، مخصوص گاڑیاں اور منصفانہ ریٹ کے ساتھ گھر اور دفتر شفٹ کرتے ہیں۔ ایک ٹیپ میں ٹرک بک کریں — یا ہمیں کال کریں۔",
            more: "ہماری خدمات دیکھیں",
        },
        marquee: [
            "گھر کی شفٹنگ",
            "دفتر کی شفٹنگ",
            "پیکرز اینڈ موورز",
            "لوڈنگ اَن لوڈنگ",
            "ٹرانسپورٹیشن",
            "رایچوٹی، آندھرا پردیش",
        ],
        services: {
            eyebrow: "ہماری خدمات",
            title: "آپ کی نقل و حجرت کی ہر ضرورت",
            sub: "پیکنگ سے لے کر ڈیلیوری تک — سب کچھ ایک جگہ۔",
            items: [
                { t: "پیکرز اینڈ موورز", d: "نازک اشیاء کے لیے ببل ریپ اور گتے کی مکمل پیکنگ۔" },
                { t: "گھر کی شفٹنگ", d: "گھر سے گھر تک — پیکنگ، لوڈنگ اور ڈیلیوری سب ہم سنبھالتے ہیں۔" },
                { t: "دفتر کی شفٹنگ", d: "آپ کے کام میں رکاوٹ کے بغیر تیز اور منظم دفتری منتقلی۔" },
                { t: "لوڈنگ اینڈ اَن لوڈنگ", d: "بھاری فرنیچر کو محفوظ طریقے سے چڑھانا اور اتارنا — تربیت یافتہ عملہ۔" },
                { t: "ٹرانسپورٹیشن", d: "تیز رفتار منتقلی کے لیے مخصوص بند ٹرک اور پک اپ گاڑیاں۔" },
            ],
        },
        install: {
            eyebrow: "انسٹال گائیڈ",
            title: "4 آسان مرحلوں میں ایپ انسٹال کریں",
            sub: "APK ڈاؤن لوڈ کرنا محفوظ ہے۔ Android ایک بار اجازت مانگے گا — یہ کریں:",
            steps: [
                "'ایپ ڈاؤن لوڈ' بٹن دبائیں — APK فائل ڈاؤن لوڈ ہونے لگے گی۔",
                "نوٹیفکیشنز یا Downloads فولڈر کھولیں اور Azmthullah_Packers_Movers.apk پر ٹیپ کریں۔",
                "اگر Android پوچھے تو Settings میں اپنے براؤزر کے لیے 'Install unknown apps' کی اجازت دیں، پھر واپس آ کر Install دبائیں۔",
                "Open دبائیں — ایپ تیار ہے۔ ایک منٹ میں ٹرک بک کریں۔",
            ],
            note: "یہ ایپ Play Store سے نہیں ہے، اس لیے فون حفاظتی تنبیہ دکھا سکتا ہے۔ صرف اسی ویب سائٹ سے انسٹال کی اجازت دینا محفوظ ہے۔",
            dlBtn: "ایپ ڈاؤن لوڈ کریں (APK)",
        },
        form: {
            eyebrow: "اپنی شفٹنگ بک کریں",
            title: "ایک منٹ میں مفت قیمت جانیں",
            sub: "فارم بھریں — ہم آپ کی تفصیلات محفوظ کر کے بہترین ریٹ پر آپ کو کال کریں گے۔",
            f: {
                name: "آپ کا نام",
                phone: "فون نمبر",
                from: "کہاں سے",
                to: "کہاں تک",
                service: "درکار سروس",
                date: "پسندیدہ تاریخ",
                details: "سامان / تفصیلات (اختیاری)",
            },
            ph: {
                name: "مثلاً محمد",
                phone: "مثلاً 99599 54280",
                from: "مثلاً رایچوٹی",
                to: "مثلاً بنگلور",
                details: "مثلاً 1 BHK، فریج، واشنگ مشین",
            },
            services: ["پیکرز اینڈ موورز", "گھر کی شفٹنگ", "دفتر کی شفٹنگ", "لوڈنگ اینڈ اَن لوڈنگ", "ٹرانسپورٹیشن"],
            pick: "سروس منتخب کریں",
            submit: "مفت قیمت حاصل کریں",
            sending: "بھیجا جا رہا ہے…",
            success: {
                title: "آپ کی درخواست مل گئی!",
                sub: "شکریہ۔ آپ کی تفصیلات محفوظ ہو گئیں — ہم جلد کال کریں گے۔ آپ ابھی ایپ ڈاؤن لوڈ بھی کر سکتے ہیں۔",
                apk: "ایپ ڈاؤن لوڈ کریں (APK)",
                apkHint: "آپ کی درخواست محفوظ ہے۔ ایپ کا ڈاؤن لوڈ فوراً شروع ہو جائے گا۔",
                wa: "واٹس ایپ پر تفصیلات بھیژیں",
                call: "ابھی کال کریں",
                again: "نئی درخواست کریں",
            },
        },
        contact: {
            eyebrow: "ہم سے رابطہ کریں",
            title: "ہم رایچوٹی میں موجود ہیں",
            addressLabel: "پتہ",
            phoneLabel: "فون",
            call: "کال کریں",
            wa: "واٹس ایپ",
            directions: "راستہ دیکھیں",
            waNote: "چیٹ شروع کرنے کے لیے نمبر پر ٹیپ کریں۔",
        },
        modal: {
            title: "عظم اللہ ایپ انسٹال کریں",
            sub: "ڈاؤن لوڈ شروع ہو گئی ہے۔ انسٹال کے لیے یہ مرحلے اپنائیں:",
            got: "ٹھیک ہے",
            again: "دوبارہ ڈاؤن لوڈ",
        },
        ctaBar: { download: "ایپ ڈاؤن لوڈ", call: "کال کریں" },
        footer: {
            tag: "پیکرز اینڈ موورز — رایچوٹی، آندھرا پردیش۔",
            rights: "جملہ حقوق محفوظ ہیں۔",
            apkNote: "آفیشل Android APK • براہ راست ڈاؤن لوڈ • انسٹال گائیڈ شامل",
        },
    },
};

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState("en");
    useEffect(() => {
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === "ur" ? "rtl" : "ltr";
    }, [lang]);
    return (
        <LangCtx.Provider value={{ lang, setLang, t: T[lang], langs: LANGS }}>
            {children}
        </LangCtx.Provider>
    );
}

export const useLang = () => useContext(LangCtx);
